// Leaflet's bindPopup/bindTooltip render their string argument as HTML, so any
// interpolated value is a stored-XSS sink for BE-provided properties (cluster /
// sampling area names, tags, etc.). Escape before composing popup/tooltip markup.
export const escapeHtml = (value: unknown): string =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
